export default __webpack_public_path__ + "8e4f1740cdd5f3d3d8e928e6f4a88c63.png";